import styled from "styled-components"
import Div from "../div/div.component"

export const StatCardContainer = styled(Div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color ${(props) => props.isCommunityPage ? "#f6f6fb" : "initial"};
  border-radius: ${(props) => props.isCommunityPage ? "3px" : "initial"};
  text-align: ${(props) => props.isCommunityPage ? "center" : "initial"};
  margin-left: ${(props) => props.isCommunityPage ? "initial" : "10px"};

  @media screen and (max-width: 780px) {
    margin-top: ${(props) => props.isCommunityPage ? "initial" : "8px"};
  }
`

export const StatCardStat = styled.h5`
  ${({ theme: { typography } }) => typography.desktop.h5};
  ${({ theme: { typography }, isCommunityPage }) =>
    isCommunityPage
      ? typography.desktop.h2
      : typography.desktop.h5
  };
  color: ${({ theme: { colors } }) => colors.accentPink};
  margin: ${(props) => props.isCommunityPage ? "0" : "0 0 10px 0"};
    font-weight: ${(props) => props.isCommunityPage ? "300" : "700"};
    font-size: ${(props) => props.isCommunityPage ? "65px" : "22px"};
    line-height: ${(props) => props.isCommunityPage ? "80px" : "32px"};

  @media screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.h5};
  color: ${({ theme: { colors } }) => colors.accentPink};
  }
`

export const StatCardLabel = styled.span`
  ${({ theme: { typography } }) => typography.desktop.excerpt};
  font-weight: ${({ theme: { fontWeight }, isCommunityPage }) =>
    isCommunityPage ? fontWeight.regular : fontWeight.semiBold
  };
  color: ${({ theme: { colors } }) => colors.black};
  text-transform: ${(props) => props.isCommunityPage ? "initial" : "uppercase"};
  font-size: ${(props) => props.isCommunityPage ? "20px" : "16px"};

   /* Conditional styles for community page */
  ${({ isCommunityPage, theme: { colors } }) => isCommunityPage && `
    &:before {
      display: block;
      margin: 40px auto 30px;
      content: "";
      width: 25px;
      height: 3px;
      background-color: ${colors.darkGrey};
    }

    @media screen and (max-width: 780px) {
      text-transform: uppercase;
      font-size: 15px;
      &::before {
        content: none;
      }
      &::after {
        display: block;
        content: "";
        background-color: ${colors.darkGrey};
        width: 25px;
        height: 3px;
        margin: 15px auto;
      }
    }
  `}
`;
